import { appConfig } from '../config';
import { HttpUnauthorizedResponseError } from './exceptions';
import processHttpResponse from './processHttpResponse';
import { getInjectorLegacy } from '../components/injectorProvider';
import { SingletonTokenRefreshService, waitForAccessToken } from '@ami/angular/core/auth';
import { firstValueFrom } from "rxjs";
import { OAuthService } from 'angular-oauth2-oidc';

function completetMissingOptions(options) {
  return Object.assign(
    {
      contentType: 'application/json',
      stringifyContent: true,
      automaticSuccessNotification: true,
    },
    options
  );
}

async function apiFetch(url, method = 'GET', payload, options, isPublic = false, init = null) {
  options = completetMissingOptions(options);

  let token = isPublic ? null : await getToken();

  let retry = true;

  // eslint-disable-next-line no-constant-condition
  while(true) {
    const request = createRequest(url, method, payload, options, isPublic, token);
    const response = await fetch(request, init);

    if(response.status === 401 && token && retry === true) {
      token = await refreshToken();

      //only retry if refresh was successful
      if(token) {
        retry = false;
        continue;
      }
    }
    else {
      return await processHttpResponse(response, { automaticSuccessNotification: options.automaticSuccessNotification }, method);
    }
  }
}

function createRequest(url, method, payload, options, isPublic, token) {
  const headers = (function () {
    const headers = new Headers();
    if (!isPublic) {
      headers.append('Authorization', `Bearer ${token}`);
    }
    if (options.contentType) {
      headers.append('Content-Type', options.contentType);
    }
    return headers;
  })();

  const body = (function () {
    if (!payload) return null;
    if (options.stringifyContent) return JSON.stringify(payload);
    return payload;
  })();

  const request = new Request(`${appConfig.baseApiUrl}${url}`, {
    method,
    headers,
    body,
  });

  return request;
}

async function getToken() {
  const injector = getInjectorLegacy();
  const oauthService = injector.get(OAuthService);
  return await firstValueFrom(waitForAccessToken(oauthService));
}

async function refreshToken() {
  const injector = getInjectorLegacy();
  const refreshService = injector.get(SingletonTokenRefreshService);
  try {
    const refreshResponse =  await firstValueFrom(refreshService.refreshToken());
    return refreshResponse.access_token;
  } 
  catch(ex) {
    console.warn("Refresh failed", ex);
    return null;
  }
}

export { apiFetch };
